// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"PageContent_spinnerWrapper__9WF4l"};